import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo } from '@apexdesigner/schema-tools';

export const tokenHistory = z
  .object({
    id: z.uuid().hidden().describe('Unique identifier'),

    eventType: z
      .enum([
        'Created',
        'Activated',
        'Advanced',
        'Moved',
        'Completed',
        'Error Occurred',
        'Script Executed',
      ])
      .describe('What happened to the token'),

    activityId: z
      .string()
      .nullable()
      .optional()
      .describe('The activity where this event occurred'),

    data: z
      .unknown()
      .nullable()
      .optional()
      .presentAs('json')
      .describe('Additional details about what changed'),

    timestamp: z.coerce
      .date()
      .nullable()
      .optional()
      .describe('When this event occurred'),

    tokenId: z.uuid().hidden().describe('Foreign key to Token'),

    token: belongsTo('Token'),
  })
  .describe("Records each significant event in a token's lifecycle")
  .as('TokenHistory');

export { tokenHistory as tokenHistorySchema };
